<template>
  <div id="app">
    <!--<img src="./assets/logo.png">-->
    <template v-if="$route.path.indexOf('/login') >= 0 || $route.path.indexOf('/recentclosedticket') >= 0">
      <router-view/>
      <!--<app-footer></app-footer>-->
    </template>
    <!--<template v-else-if="$route.path.indexOf('/recentclosedticket') >= 0">
      <router-view/>
    </template>-->

    <template v-else>
      <app-header></app-header>
      <div id="wrapper" class="app-sidebar-right">
        <app-sidebar></app-sidebar>
        <router-view></router-view>
      </div>
    </template>

  </div>
</template>

<script>
    require("@babel/polyfill");

    import FrontHeader from '@/components/FrontHeader';
    import FrontFooter from '@/components/FrontFooter';
    import Sidebar from '@/components/Sidebar'

    var self;
    export default {
        name: 'App',
        data() {
            return {

            }
        },
        components: {
            'app-header': FrontHeader,
            'app-footer': FrontFooter,
            'app-sidebar': Sidebar
        },
        // Watching Route to see if we have reached "/" route.
        // If Yes route back to CloseTicket
        watch: {
          
        },
        beforeMount: function () {
            var self = this;
        },
        mounted: function () {
            var self = this;
            var userObj = JSON.parse(localStorage.getItem("user_obj"));
            var pathname = window.location.pathname;
            var segments = pathname.split('/');// if (segments[1]) {
            if (userObj === null) {
                self.$router.push("/login");
            } else {
                if (segments[1] === '') {
                    //self.$router.push("/closeticket");
                    self.$router.push("/");
                } else {
                    return;
                }
            }
        },
        methods: {

        },
    }
</script>

<!--<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
-->


// WEBPACK FOOTER //
// src/App.vue